import { render, staticRenderFns } from "./StripeFees.vue?vue&type=template&id=6e984190&scoped=true&"
import script from "./StripeFees.vue?vue&type=script&lang=js&"
export * from "./StripeFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e984190",
  null
  
)

export default component.exports